import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface CampaignParticipateRequest {
    fingerprintHash: string;
    participantName?: string;
}

export interface CampaignParticipateResponse {
    resolvedGameType: 'WHEEL' | 'SCRATCH';
    prize: {
        label: string;
    };
    allPrizes: {
        label: string;
    }[];
}

@Injectable({
    providedIn: 'root'
})
export class CampaignReviewService {

    /** When set, the game is in preview/test mode (no participation saved). */
    previewToken: string | null = null;

    /** Whether the current session is in preview mode (set after check response). */
    isPreviewMode = false;

    constructor(private _httpClient: HttpClient) {}

    /**
     * Participate in the campaign (draw a prize).
     */
    participate(campaignId: number, fingerprintHash: string, participantName?: string): Observable<CampaignParticipateResponse> {
        const body: CampaignParticipateRequest = { fingerprintHash };
        if (participantName) {
            body.participantName = participantName;
        }
        // The preview token travels in a header, never in the URL (logged by the Heroku router).
        let headers = new HttpHeaders();
        if (this.previewToken) {
            headers = headers.set('X-Preview-Token', this.previewToken);
        }
        return this._httpClient.post<CampaignParticipateResponse>(
            `${environment.api}/campaigns/review/${campaignId}/participate`,
            body,
            { headers }
        );
    }
}
